import { axios } from '../utils'
import { RelationProductList } from 'common/types/entities/list'
import { RelationProductParam } from '../types/params/list'
import { RelationProduct } from 'common/types/entities/mongo/relationProduct'

export const fetchRelationProductList = async (params: RelationProductParam): Promise<RelationProductList> => {
  const response = await axios.get<RelationProductList>(`/v1/relation-products`, { params })
  return response && response.data
}

export const fetchRelationProductForList = async (
  id: string,
  params: RelationProductParam,
): Promise<RelationProduct> => {
  const response = await axios.get<RelationProduct>(`/v1/relation-products/${id}/list-type`, { params })
  return response && response.data
}

export const fetchRelationProduct = async (relationProductId: string): Promise<RelationProduct> => {
  const response = await axios.get<RelationProduct>(`/v1/relation-products/${relationProductId}`)
  return response && response.data
}

export const fetchRelationProductPreview = async (relationProductId: string): Promise<RelationProduct> => {
  const response = await axios.get<RelationProduct>(`/v1/relation-products/${relationProductId}/preview`)
  return response && response.data
}
